import { Pipe, PipeTransform } from '@angular/core';
import { CourierProfileService } from '../services/courier-profile.service';
import { Observable } from 'rxjs';

@Pipe({
    name: 'courierName$',
    standalone: true
})
export class CourierNamePipe implements PipeTransform {

    constructor(private courierProfileService: CourierProfileService) {
    }


    transform(value: string): Observable<string> {
        return this.courierProfileService.getCourierName(value);
    }

}
